import { Outlet, Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useRef } from "react";

function ProtectedRouterLogin() {
    const userToken = localStorage.getItem("crymadx");
    const tokenExpiry = localStorage.getItem("ts");
    const now = new Date().getTime();
    const hasToasted = useRef(false);

    const isTokenExpired = !tokenExpiry || now > Number(tokenExpiry);

    useEffect(() => {
        if ((!userToken || isTokenExpired) && !hasToasted.current) {
            // Clear token if expired
            localStorage.removeItem("crymadx");
            localStorage.removeItem("ts");

            setTimeout(() => {
                toast.dismiss();
                toast.error("Please login to continue");
            }, 300);
            hasToasted.current = true;
        }
    }, [userToken, isTokenExpired]);

    return userToken && !isTokenExpired ? <Outlet /> : <Navigate to="/login" />;
}

export default ProtectedRouterLogin;
